import Joyride, { type CallBackProps } from "react-joyride";
import { joyrideLocale, joyrideStyles } from "./joyrideConfig";
import { otRuleEditTourSteps } from "./otRuleEditTourSteps";
import { useOvertimeTour } from "./useOvertimeTour";

const TOUR_STORAGE_KEY = "hr-overtime-rule-edit-tour-completed";

type OTRuleEditTourProps = {
  run: boolean;
  onCallback: (data: { status?: string; type?: string; index?: number }) => void;
};

export function OTRuleEditTour({ run, onCallback }: OTRuleEditTourProps) {
  const handleCallback = (data: CallBackProps) => {
    onCallback({ status: data.status, type: data.type, index: data.index });
  };

  return (
    <Joyride
      steps={otRuleEditTourSteps}
      run={run}
      continuous
      showProgress
      showSkipButton
      callback={handleCallback}
      locale={joyrideLocale}
      styles={joyrideStyles}
      scrollToFirstStep
      scrollOffset={24}
      scrollDuration={300}
    />
  );
}

export function useOTRuleEditTour() {
  return useOvertimeTour(TOUR_STORAGE_KEY);
}
